"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _core = require("@material-ui/core/");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _core.makeStyles)(theme => ({
  item: {
    borderBottom: "1px solid " + theme.palette.grey[300],
    display: "flex",
    justifyContent: "space-between",
    padding: theme.spacing(1.5, 0)
  },
  title: {},
  phonenumber: {}
}));
const PhoneNumbers = _ref => {
  let {
    providers
  } = _ref;
  const [data, setData] = (0, _react.useState)();
  const {
    i18n
  } = (0, _reactI18next.useTranslation)();
  (0, _react.useEffect)(() => {
    async function fetchData() {
      const {
        REACT_APP_PATH,
        REACT_APP_PROVIDER_ID
      } = process.env;
      const fetchURL = "".concat(REACT_APP_PATH, "/Micado.Tourism.Web/Micado.Tourism.Web.IO.Api.ProviderApi/ListFacilities.api?providers=").concat(providers ? providers : REACT_APP_PROVIDER_ID, "&lang=").concat(i18n.language);
      const response = await fetch(fetchURL);
      setData(await response.json());
    }
    fetchData();
  }, [i18n.language, providers]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, data === null || data === void 0 ? void 0 : data.items.map(item => {
    return /*#__PURE__*/_react.default.createElement(Item, {
      key: item.id,
      title: item.title,
      phonenumber: item.phone
    });
  }));
};
const Item = _ref2 => {
  let {
    title,
    phonenumber
  } = _ref2;
  const css = useStyles();
  if (!phonenumber || !title) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: css.item
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: css.title
  }, title), phonenumber.indexOf("+43") > -1 ? /*#__PURE__*/_react.default.createElement("a", {
    className: css.phonenumber,
    href: "tel:" + phonenumber
  }, phonenumber) : /*#__PURE__*/_react.default.createElement("p", {
    className: css.phonenumber
  }, phonenumber));
};
var _default = exports.default = PhoneNumbers;